const appConfig = window.APP_CONFIG || {};

// Fallback endpoint для PWA: если APP_CONFIG не задан сервером,
// используем путь относительно текущего хоста
if (!appConfig.endpoint) {
    appConfig.endpoint = '/telegram/client/api';
}

// Добавляем методы для работы с токеном
appConfig.token = localStorage.getItem("token") || null;
appConfig.user = localStorage.getItem("user") || null;

appConfig.setToken = (newToken) => {
    appConfig.token = newToken;
    localStorage.setItem("token", newToken);
};

appConfig.clearToken = () => {
    appConfig.token = null;
    localStorage.removeItem("token");
};

appConfig.setUser = (user) => {
    appConfig.user = user;
    localStorage.setItem("user", user);
};

appConfig.getUser = () => {
    if (appConfig.user) {
        try {
            return JSON.parse(appConfig.user);
        } catch (e) {
            console.error("Failed to parse user from localStorage:", e);
            return null;
        }
    }
    return null;
}

appConfig.clearUser = () => {
    appConfig.user = null;
    localStorage.removeItem("user");
};

// Метод для авторизованных запросов
appConfig.authFetch = async (url, options = {}) => {
    const defaultOptions = {
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    };

    // Добавляем токен если он есть
    if (appConfig.token) {
        defaultOptions.headers['Authorization'] = `Bearer ${appConfig.token}`;
    }

    const response = await fetch(url, { ...defaultOptions, ...options });

    // Если токен протух или невалиден
    if (response.status === 401) {
        appConfig.clearToken();
        appConfig.clearUser();
        const slug = new URLSearchParams(window.location.search).get('slug');
        const basePath = window.APP_CONFIG?.basePath || '/app';
        const target = window.location.origin + basePath + (slug ? '?slug=' + slug : '');
        // Редиректим только если ещё не там — предотвращает бесконечный цикл
        if (window.location.href !== target) {
            window.location.href = target;
        }
    }

    return response;
};

// Валидация конфига
appConfig.validate = () => {
    const requiredFields = ['endpoint'];
    const missingFields = requiredFields.filter(field => !appConfig[field]);

    if (missingFields.length > 0) {
        console.error('Missing required config fields:', missingFields);
        return false;
    }

    return true;
};

export default appConfig;